<script>
import {Bar} from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['userAccessByDay'],
  // data() {
  //   return {
  //   }
  // },
  computed: {
    chartData: function() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: this.$t('Analysis.User.male'),
            borderColor: '#009CE1',
            borderWidth: 1.5,
            backgroundColor: '#009CE1',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#009CE1',
            data: this.countsForGender('male')
          },
          {
            label: this.$t('Analysis.User.female'),
            borderColor: '#99D7F3',
            borderWidth: 1.5,
            backgroundColor: '#99D7F3',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: '#99D7F3',
            data: this.countsForGender('female')

          },
          {
            label: this.$t('Analysis.User.other'),
            borderColor: '#EEEEEE',
            borderWidth: 1.5,
            backgroundColor: 'rgba(0,0,0,0.1)',
            pointRadius: 0,
            pointHitRadius: 4,
            pointHoverBackgroundColor: 'rgba(0,0,0,0.1)',
            data: this.countsForGender('other')

          }
        ]
      }
    },
    labels: function() {
        return Object.keys(this.userAccessByDay).sort();
    }
  },
  mounted() {
    let obj = this;
    var i = 0;
    this.options = {
      legend: {
        display: true,
        position: "bottom",
        padding: 0
      },
      tooltips: {
        mode: 'x-axis',
        intersect: false,
        position: 'nearest'
      },
      scales: {
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false
          },
          ticks: {
            fontColor: "#999",
            callback: function(value, index, values){
              return value.replace(/20[0-9]{2}\//g, "")
            }
          }
        }],
        yAxes: [{
          stacked: true,
          ticks: {
            min: 0,
            fontColor: "#999"
          }
        }]
      },
      responsive: true,
      maintainAspectRatio: false,
      spanGaps: true,
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        datalabels: {
          display: false
        }
      }
    };
    this.renderChart(this.chartData,this.options);
  },
  methods: {
    countsForGender: function(gender) {
      return this.labels.map(date => {
        const counts = this.userAccessByDay[date][gender] || { };
        let value = Object.values(counts).reduce((a,v)=>a+v,0);
        if (gender === 'other') {
            const unknownCounts = this.userAccessByDay[date]['_unknown'] || { };
            value += Object.values(unknownCounts).reduce((a,v)=>a+v,0);
        }
        return value;
      });
    }
  },
  watch : {
    userAccessByDay: function() {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
